import { Composition } from "remotion";
import { FPS } from "./lib/constants";
import VideoEngine from "./components/engine/VideoEngine";
import { aiVisionDemoConfig } from "./videos/ai-vision-demo";
import { newDemoConfig } from "./videos/new-demo";
import { integrationTestConfig } from "./videos/integration-test";
import { imageDemoConfig } from "./videos/image-demo";
import { horrorDemoConfig } from "./videos/horror-demo";
import { modelShowcaseConfig, modelShowcaseBgm } from "./videos/model-showcase";
import { bossCommunicationConfig, bossCommunicationBgm } from "./videos/boss-communication";
import { subtitleDemoConfig } from "./videos/subtitle-demo";
export const RemotionRoot: React.FC = () => {
  const totalDuration1 = aiVisionDemoConfig.reduce(
    (sum, s) => sum + s.durationInFrames,
    0,
  );
  const totalDuration2 = newDemoConfig.reduce(
    (sum, s) => sum + s.durationInFrames,
    0,
  );
  const totalDuration3 = integrationTestConfig.reduce(
    (sum, s) => sum + s.durationInFrames,
    0,
  );

  return (
    <>
      <Composition
        id="AIVisionDemo"
        component={VideoEngine}
        width={1080}
        height={1920}
        fps={FPS}
        durationInFrames={totalDuration1}
        defaultProps={{
          scenes: aiVisionDemoConfig,
        }}
      />
      <Composition
        id="NewDemo"
        component={VideoEngine}
        width={1080}
        height={1920}
        fps={FPS}
        durationInFrames={totalDuration2}
        defaultProps={{
          scenes: newDemoConfig,
        }}
      />
      <Composition
        id="IntegrationTest"
        component={VideoEngine}
        width={1080}
        height={1920}
        fps={FPS}
        durationInFrames={totalDuration3}
        defaultProps={{
          scenes: integrationTestConfig,
        }}
      />
      <Composition
        id="ImageDemo"
        component={VideoEngine}
        width={1080}
        height={1920}
        fps={FPS}
        durationInFrames={imageDemoConfig.reduce((s, c) => s + c.durationInFrames, 0)}
        defaultProps={{
          scenes: imageDemoConfig,
        }}
      />
      <Composition
        id="HorrorDemo"
        component={VideoEngine}
        width={1080}
        height={1920}
        fps={FPS}
        durationInFrames={horrorDemoConfig.reduce((s, c) => s + c.durationInFrames, 0)}
        defaultProps={{
          scenes: horrorDemoConfig,
        }}
      />
      <Composition
        id="ModelShowcase"
        component={VideoEngine}
        width={1080}
        height={1920}
        fps={FPS}
        durationInFrames={modelShowcaseConfig.reduce((s, c) => s + c.durationInFrames, 0)}
        defaultProps={{
          scenes: modelShowcaseConfig,
          bgm: modelShowcaseBgm,
        }}
      />
      <Composition
        id="BossCommunication"
        component={VideoEngine}
        width={1080}
        height={1920}
        fps={FPS}
        durationInFrames={bossCommunicationConfig.reduce(
          (s, c) => s + c.durationInFrames,
          0,
        )}
        defaultProps={{
          scenes: bossCommunicationConfig,
          bgm: bossCommunicationBgm,
        }}
      />
    <Composition
      id="SubtitleDemo"
      component={VideoEngine}
      width={1080}
      height={1920}
      fps={FPS}
      durationInFrames={subtitleDemoConfig.reduce(
        (s, c) => s + c.durationInFrames,
        0,
      )}
      defaultProps={{
        scenes: subtitleDemoConfig,
        }}
      />
      </>
  );
};
;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
